import { Image } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function TwoColList(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container-lg mb-10 md:mb-16 mt-8 overflow-hidden relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-4xl mx-auto relative z-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 lg:pb-20 mb-10 lg:mb-20 last:pb-0 last:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("md:flex md:gap-x-9", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:w-1/2"
    }, props.image && /*#__PURE__*/ React.createElement(Image, {
        source: props.image.source,
        alt: props.image.alt,
        className: "w-full max-w-full mb-9 lg:mb-0"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "md:w-1/2 mb-2 lg:mb-0"
    }, props.list.map(function(section, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "block text-lg prose border-b-4 border-b-yellow-500 pb-5 mb-5"
        }, /*#__PURE__*/ React.createElement("h4", {
            className: "mb-1"
        }, section.heading), /*#__PURE__*/ React.createElement("p", {
            className: "text-base lg:text-xl"
        }, section.description));
    }))))));
}
